import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { getActionTouchpointTypeLabel } from "utilities";

import { CreatableTouchpointType } from "types/touchpoint";
import {
  classesValidation,
  copyCodeField,
  populationTypeValidation,
  requiredFiscalYearField,
} from "components/modals/creative-modal/creative-modal-consts";

export const getCreateTouchpointFromProgramTemplateSchema = (
  touchpointType: CreatableTouchpointType,
) => {
  const touchpointLabel = getActionTouchpointTypeLabel(touchpointType);

  return z.object({
    campaignId: z
    .string({ required_error: "Campaign name is required" })
    .nonempty({ message: "Campaign name is required" }),
    name: z
    .string({ required_error: `${touchpointLabel} name is required` })
    .nonempty({ message: `${touchpointLabel} name is required` }),
    insightsActivator: z.boolean().optional(),
    populationType: populationTypeValidation,
    contentType: z
      .string({ required_error: "Content type is required" })
      .nonempty({ message: "Content type is required" }),
    fiscalYear: requiredFiscalYearField,
    copyCode: copyCodeField,
    classes: classesValidation,
  });
};

export const getCreateTouchpointFromProgramTemplateValidationSchema = (
  touchpointType: CreatableTouchpointType,
) => zodResolver(getCreateTouchpointFromProgramTemplateSchema(touchpointType));
